module.exports = __webpack_public_path__ + "static/img/ptld_7@2x.20b272bf.png";